var initScrollDown = function() {
    jQuery('#scroll-down-trigger').on('click', function(e) {
        e.preventDefault();
        var target = jQuery(this).data('target');
        smoothScroll(jQuery('#' + target));
    });
};

function smoothScroll(target) {
    jQuery('body,html').animate(
        {'scrollTop' : target.offset().top},
        600
    );
}

export {
    initScrollDown
};